export const getters = {
  searchKey (state) {
    return state.searchKey;
  }
};
